// Progressive enhancement: every story is visible before JavaScript runs.
// Animate decorations only; the illustration and reading column stay intact.
function $3cc8bb170698a5c9$export$2549f96d24034324(root = document, view = window) {
    if (typeof view.matchMedia !== 'function') return;
    const preference = view.matchMedia('(prefers-reduced-motion: reduce)');
    const decorations = [
        ...root.querySelectorAll('[data-parallax]')
    ];
    const stories = [
        ...root.querySelectorAll('[data-reveal]')
    ];
    let observer;
    let frame = 0;
    const paint = ()=>{
        frame = 0;
        for (const element of decorations){
            const rect = element.parentElement.getBoundingClientRect();
            if (rect.bottom < 0 || rect.top > view.innerHeight) continue;
            const offset = Math.max(-90, Math.min(90, -rect.top * Number(element.dataset.parallax)));
            element.style.setProperty('--parallax-y', `${offset.toFixed(1)}px`);
        }
    };
    const schedule = ()=>{
        if (!frame) frame = view.requestAnimationFrame(paint);
    };
    const reset = ()=>{
        observer?.disconnect();
        observer = undefined;
        view.removeEventListener('scroll', schedule);
        view.removeEventListener('resize', schedule);
        if (frame) view.cancelAnimationFrame(frame);
        frame = 0;
        for (const element of decorations)element.style.removeProperty('--parallax-y');
        for (const story of stories)story.classList.remove('story-entering');
    };
    const start = ()=>{
        reset();
        if (preference.matches) return;
        if (typeof view.IntersectionObserver === 'function') {
            observer = new view.IntersectionObserver((entries)=>{
                for (const entry of entries){
                    if (!entry.isIntersecting) continue;
                    entry.target.classList.add('story-entering');
                    observer.unobserve(entry.target);
                }
            }, {
                threshold: 0.08
            });
            for (const story of stories)observer.observe(story);
        }
        if (decorations.length && typeof view.requestAnimationFrame === 'function') {
            view.addEventListener('scroll', schedule, {
                passive: true
            });
            view.addEventListener('resize', schedule, {
                passive: true
            });
            schedule();
        }
    };
    start();
    preference.addEventListener?.('change', start);
    return ()=>{
        reset();
        preference.removeEventListener?.('change', start);
    };
}
function $3cc8bb170698a5c9$export$2009f5127927d50a(root = document, view = window) {
    const progress = root.querySelector('[data-reading-progress]');
    const article = root.querySelector('article[data-article-slug]');
    const body = article?.querySelector('.article-body');
    if (!progress || !body || typeof view.requestAnimationFrame !== 'function') return;
    let frame = 0;
    const paint = ()=>{
        frame = 0;
        const start = body.getBoundingClientRect().top + view.scrollY - 120;
        const end = article.getBoundingClientRect().bottom + view.scrollY - view.innerHeight;
        const amount = Math.max(0, Math.min(1, (view.scrollY - start) / Math.max(1, end - start)));
        progress.style.setProperty('--reading-progress', amount.toFixed(4));
        progress.hidden = false;
    };
    const schedule = ()=>{
        if (!frame) frame = view.requestAnimationFrame(paint);
    };
    view.addEventListener('scroll', schedule, {
        passive: true
    });
    view.addEventListener('resize', schedule, {
        passive: true
    });
    schedule();
    return ()=>{
        view.removeEventListener('scroll', schedule);
        view.removeEventListener('resize', schedule);
        if (frame) view.cancelAnimationFrame(frame);
        progress.style.removeProperty('--reading-progress');
        progress.hidden = true;
    };
}
$3cc8bb170698a5c9$export$2549f96d24034324();
$3cc8bb170698a5c9$export$2009f5127927d50a();


//# sourceMappingURL=blog.2a2bc195.js.map
